import React, { useCallback, useEffect } from 'react';
import WorkspaceReportsTable from '../molecules/WorkspaceReportsTable';
import {
  MotifButton,
  MotifCard,
  MotifCardBody,
  MotifCardHeader,
  MotifFormField,
  MotifSearch
} from '@ey-xd/motif-react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import AddUpdateTrainingDocument from '../molecules/AddUpdateTrainingDocument';
import AdminTrainingsLIstTable from '../molecules/AdminTrainingsLIstTable';
import axios from 'axios';

const AdminTrainings = () => {
  const [trainingAddOrUpdateEnabled, setTrainingAddOrUpdateEnabled] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const { access } = useSelector((state: any) => state.user);
  const { trainings } = useSelector((state: any) => state.admin);
  const dispatch = useDispatch();
  const params = useParams();
  const [search, setSearch] = React.useState('');

  const downloadTrainingTemplate = async () => {
    try {
      const response = await axios.get(`/training/template`);
      const templateData = response?.data;
      console.log("templateDatatemplateData", templateData);
      window.open(templateData?.templateURL, '_self');
    } catch(err) {
      console.log("error", err);
    }
  }

  useEffect(() => {
    if (access.read) {
      dispatch(
        {
          type: 'GET_TRAININGS_LIST'
        },
        {}
      );
    }
  }, [access]);

  const toggleReportAddOrUpdateEnabled = () => {
    setTrainingAddOrUpdateEnabled(!trainingAddOrUpdateEnabled);
  };

  const trainingsList = useCallback(() => {
    if (trainingAddOrUpdateEnabled === true) return <></>;
    const reports =
      search === ''
        ? trainings
        : trainings?.filter((wksp: any) => {
            if (
              wksp.fileName.toLowerCase().includes(search.toLowerCase()) ||
              wksp.createdDate.toLowerCase().includes(search.toLowerCase()) ||
              wksp.status.toLowerCase().includes(search.toLowerCase())
            ) {
              return wksp;
            }
          });

    return (
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center gap-3">
          <h3>Below listed are the tranings you created:</h3>
          <div className="flex justify-between items-center gap-3">
            <MotifFormField className="!max-w-[20rem] !mb-0">
              <MotifSearch
                aria-label="Search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onSelect={function Xo() {}}
                placeholder="Search for..."
                value={search}
                maxLength={25}
              />
            </MotifFormField>
            {access?.write === true && (
              <MotifButton
                size="medium"
                onClick={() => {
                  dispatch({ type: 'WORKSPACE_CLEAR_REPORT_DETAILS' });
                  setTrainingAddOrUpdateEnabled(true);
                  setIsEdit(false);
                }}
                variant="primary"
              >
                Add new training
              </MotifButton>
            )}
             <MotifButton
                size="medium"
                onClick={downloadTrainingTemplate as any}
                variant="secondary"
              >
                View template
              </MotifButton>
          </div>
        </div>
        <div>
          <AdminTrainingsLIstTable
            tableData={reports}
            onOpenReport={() => {
              setTrainingAddOrUpdateEnabled(true);
              setIsEdit(true);
            }}
          />
        </div>
      </div>
    );
  }, [trainingAddOrUpdateEnabled, trainings, search]);

  const addNewTraining = useCallback(() => {
    if (trainingAddOrUpdateEnabled === false) return <></>;
    return (
      <AddUpdateTrainingDocument
        onCancel={() => {
          toggleReportAddOrUpdateEnabled();
        }}
        isEdit={isEdit}
      />
    );
  }, [trainingAddOrUpdateEnabled]);
  return (
    <div className="flex flex-col min-h-full m-3">
      <MotifCard className="min-h-[50vh] !bg-[transparent]">
        <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
          <div className="flex gap-10 items-center !justify-between !w-full">
            <h4 className="!py-3 !font-bold">Trainings</h4>
          </div>
        </MotifCardHeader>
        <MotifCardBody className="!min-h-80">
          {trainingsList()}
          {addNewTraining()}
        </MotifCardBody>
      </MotifCard>
    </div>
  );
};

export default AdminTrainings;
